import { Box, Tab, Tabs } from "@mui/material";
import TimelineHeader from "components/Headers/SimpleHeader";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "./Components/Modal";
import { cyanBlue } from "pages/TenantDetails/constants/Constants";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import { getAdminUserList } from "action/plans";
import { changeStatus } from "action/plans";
import Swal from "sweetalert2";

function AddUser() {
  const dispatch = useDispatch();
  const adminUserList = useSelector(
    (state) => state.TenantDetailsReducer.adminUserList
  );
  const [isLoading, setIsLoading] = useState({
    pageLoader: true,
    switchLoading: false,
    switchId: null,
  });
  const [error, setError] = useState(false);
  const [modal, setModal] = React.useState(false);
  const [userList, setUserList] = React.useState();

  React.useEffect(() => {
    getAdminUserList(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    if (adminUserList.code) {
      if (adminUserList.code === 200) {
        setError(false);
        setUserList(adminUserList?.data?.adminUserList);
        setIsLoading((prev) => ({ ...prev, pageLoader: false }));
      } else {
        setError(true);
        setIsLoading((prev) => ({ ...prev, pageLoader: false }));
      }
    } else {
      setError(false);
      setIsLoading((prev) => ({ ...prev, pageLoader: true }));
    }
  }, [adminUserList]);

  const toggle = () => {
    setModal(!modal);
  };

  const changeUserStatus = async (e, row) => {
    Swal.fire({
      text: `Are you sure you want to ${
        row.status === "INACTIVE" ? "Active" : "In-Active"
      } this user?`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      icon: "warning",
      focusCancel: true,
      customClass: {
        confirmButton: "bg-info",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        handleChangeUsedStatus(e, row);
      }
    });
  };

  const handleChangeUsedStatus = async (e, row) => {
    setIsLoading((prev) => ({
      ...prev,
      switchLoading: true,
      switchId: row.userID,
    }));
    let data = {
      status: "",
    };
    if (e.target.checked) {
      data = {
        status: "INACTIVE",
      };
    } else {
      data = {
        status: "ACTIVE",
      };
    }
    const res = await changeStatus(row.userID, data);
    setTimeout(() => {
      setIsLoading((prev) => ({
        ...prev,
        switchLoading: false,
        switchId: null,
      }));
    }, 1000);
    if (res?.status === 200) {
      getAdminUserList(dispatch);
    } else {
      Swal.fire({
        title: "Something went wrong",
        text: "Please try again later",
        icon: "error",
        timer: 3000,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  };

  return (
    <>
      <TimelineHeader />
      <Container fluid className="mt--5">
        <AddModal modal={modal} toggle={toggle} />
        <Card>
          <CardBody>
            <Row className=" px-3 d-flex justify-content-between">
              <h3 className="mb-0">Add User</h3>
              <Button
                onClick={() => toggle()}
                outline
                color="info"
                className="mb-0"
              >
                Add User
              </Button>
            </Row>
            <Row lg="12" md="12" sm="12">
              {isLoading.pageLoader ? (
                <div style={styles.loaderContainer}>
                  <i
                    className="fa fa-spinner fa-spin fa-2xl"
                    style={styles.loaderColor}
                  />
                </div>
              ) : error ? (
                <>
                  <div style={styles.loaderContainer}>Something went wrong</div>
                </>
              ) : (
                <>
                  {userList?.length > 0 ? (
                    <ToolkitProvider
                      data={userList ? userList : []}
                      keyField="ID"
                      columns={[
                        {
                          dataField: "userID",
                          text: "ID",
                          sort: true,
                        },
                        {
                          dataField: "name",
                          text: "Name",
                          sort: true,
                        },
                        {
                          dataField: "Email",
                          text: "Email",
                          sort: true,
                        },
                        {
                          dataField: "role",
                          text: "Role",
                          sort: true,
                        },
                        {
                          dataField: "accType",
                          text: "Actions",
                          align: "right",
                          headerAlign: "left",
                          events: { onClick: (e) => e.stopPropagation() },
                          formatter: (cell, row) => (
                            <div
                              style={styles.archiveTenantAction}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {isLoading.switchLoading &&
                              isLoading.switchId === row.userID ? (
                                <div>
                                  <i
                                    className="fa fa-spinner fa-spin fa-xl"
                                    style={styles.loaderColor}
                                  />
                                </div>
                              ) : (
                                <>
                                  <label className="custom-toggle custom-toggle-info">
                                    <Input
                                      disabled={
                                        isLoading.switchLoading &&
                                        isLoading.switchId === row.userID
                                      }
                                      checked={
                                        row.status === "INACTIVE" ? false : true
                                      }
                                      type="checkbox"
                                      onChange={(e) => changeUserStatus(e, row)}
                                    />
                                    <span
                                      className="custom-toggle-slider rounded-circle"
                                      data-label-off="InAc"
                                      data-label-on="Act"
                                    ></span>
                                  </label>
                                </>
                              )}
                            </div>
                          ),
                        },
                      ]}
                      search
                    >
                      {(props) => (
                        <div className="py-4 table-responsive">
                          <BootstrapTable
                            {...props.baseProps}
                            bootstrap4={true}
                            // pagination={pagination}
                            bordered={false}
                            rowStyle={{ cursor: "pointer" }}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  ) : (
                    <div style={styles.loaderContainer}>No Records Found!</div>
                  )}
                </>
              )}
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default AddUser;

const styles = {
  loaderColor: { color: cyanBlue },
  loaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "50vh",
    width: "100%",
  },
  loaderText: {
    fontWeight: "normal",
  },
  archiveTenantAction: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: "0.5rem",
  },
};
